import {Component, Input, OnInit} from '@angular/core';
import {DialogComponent} from "../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {NotificationDialogService} from "./notification-dialog.service";

export interface INotificationDialogData {
  header: string;
  message: string;
  buttonText?: string;
  buttonAlign?: string;
  textAlign?: string;
  mainClass?: string;
  width?: number;
  hasCloseButton?: boolean;
  showCancelButton?: boolean;
  showSuccess?: boolean;
  withTimer?: number;
  buttonColor?: string;
  buttonSize?: string;
  submitBtnClass?: string;
  cancelBtnClass?: string;
  action?: string;
  image?: boolean;
  hasAdminLink?: boolean;
  hasGradientBorder?: boolean;
  adminLink?: string;
  websiteId?: number;
  forDemo?: boolean;
  forEcommerce?: boolean;
  hasNotice?: boolean;
  gradientBorder?: string;
  withBlur?: boolean;
  showLottie?: boolean;
  combinedHeader?: boolean;
  withBlackBlur?: boolean;
}

@Component({
    selector: 'db-notification-dialog',
    templateUrl: './notification-dialog.component.html',
    styleUrls: ['./notification-dialog.component.scss'],
    standalone: false
})
export class NotificationDialogComponent extends DialogComponent<INotificationDialogData, any> implements OnInit {

  @Input() header: string;
  @Input() message: string;
  @Input() hasCloseButton?: boolean = false;
  @Input() showCancelButton?: boolean = false;
  @Input() showSuccess?: boolean = true;
  @Input() withTimer?: number = 0;
  @Input() buttonText: string;
  @Input() buttonSize: string;
  @Input() buttonColor: 'blue' | 'green' | 'red' | 'black' = 'blue';
  @Input() buttonAlign?: 'left' | 'right' | 'center' = 'center';
  @Input() textAlign?: 'left' | 'right' | 'center' = 'center';
  @Input() action?: string;
  @Input() width?: number;
  @Input() redirectTo?: any;
  @Input() hasGradientBorder?: boolean;
  @Input() hasAdminLink?: boolean = false;
  @Input() adminLink?: string;
  @Input() websiteId?: number;
  @Input() image?: boolean = false;
  @Input() showLottie?: boolean = false;
  @Input() forDemo?: boolean = false;
  @Input() forEcommerce?: boolean = false;
  @Input() hasNotice?: boolean = false;
  @Input() combinedHeader?: boolean = false;
  @Input() gradientBorder?: string;
  @Input() mainClass?: string;
  @Input() withBlur?: boolean;
  @Input() withBlackBlur?: boolean = false;
  public isMobile: boolean = false;
  lottieConfig: any;
  constructor(
    private _dialogService: DialogService,
    private _notificationDialogService: NotificationDialogService,
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.lottieConfig = {
      path: 'assets/images/lotties/success-lottie.json',
      renderer: 'svg',
      autoplay: true,
      loop: true
    };
    this.isMobile = window.innerWidth <= 991;

    if (this.withTimer) {
      setTimeout(() => {
        this.close();
      }, this.withTimer);
    }
  }

  public onClick(event): void {
    /* this._notificationDialogService.btnClicked.next(true);*/
    this.result = this.action;
    this.close();
  }
}
